import type { State, Action, Reducer, TabName } from '../use_candidate_profile';
import { tabMap } from '../use_candidate_profile';

export const tabReducer: Reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'setTab': {
      return {
        ...state,
        currentTab: tabMap[action.payload.index] as TabName,
      };
    }
    case 'setRightBarTab': {
      return {
        ...state,
        currentRightBarTab: action.payload.tab,
        isRightBarOpen: true,
      };
    }
    case 'setGlobalModal': {
      let props: Record<string, any> | null;

      if (action.payload.props) {
        props = action.payload.props;
      } else {
        props = null;
      }

      return {
        ...state,
        globalModal: {
          ...state.globalModal,
          [action.payload.modal]: [action.payload.state, props],
        },
      };
    }
    case 'setRightBarTabOpen': {
      return {
        ...state,
        isRightBarOpen: action.payload.open,
        currentRightBarTab: action.payload.open
          ? state.currentRightBarTab
          : null,
      };
    }
    case 'setHeader': {
      return {
        ...state,
        header: action.payload.header,
      };
    }
    case 'setHeaderSource': {
      return {
        ...state,
        header: {
          ...state.header,
          statusLabels: {
            ...state.header.statusLabels,
            source: action.payload.source,
          },
        },
      };
    }
    case 'setHeaderDepartmentAndOffice': {
      return {
        ...state,
        header: {
          ...state.header,
          department: action.payload.department,
          offices: action.payload.office ? [action.payload.office] : [],
        },
      };
    }
    case 'setAllApplicationsRightbar': {
      return {
        ...state,
        allApplicationsRightbar: {
          ...state.allApplicationsRightbar,
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};
